export const formatDiscountPercentage = (value) => {
  const percentage = Number(value);
  if (!Number.isFinite(percentage)) return "0";

  return percentage.toLocaleString("en-US", {
    useGrouping: false,
    maximumFractionDigits: 8,
  });
};
